import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: 100px;\n  border-width: 0;\n  color: ", ";\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  height: 34px;\n  margin: 0 6px;\n  position: relative;\n  transition: opacity 150ms ease-in-out;\n  width: 74px;\n\n  &:hover {\n    opacity: 0.9;\n  }\n\n  &:focus {\n    outline: none;\n    opacity: 0.9;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin: 20px 0;\n  width: 100%;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  overflow: hidden;\n  padding: 80px 24px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { compose, defaultProps, pure, withHandlers, withProps } from 'recompose';
import { Ink } from '../Ink';
import { CurrencyInput } from '../Form/CurrencyInput';
import styled from '../utils/styling/styled-components';
var Container = styled.div(_templateObject());
var PresetValues = styled.div(_templateObject2());
var ValueButton = styled.button(_templateObject3(), function (props) {
  return props.isSelected ? props.theme.colors.green : props.theme.colors.ivory;
}, function (props) {
  return props.isSelected ? props.theme.colors.white : props.theme.colors.slate;
});
var enhance = compose(defaultProps({
  value: ''
}), withProps(function (_ref) {
  var values = _ref.values;
  return {
    values: values || ['5', '25', '50', '100']
  };
}), withHandlers({
  handleClick: function handleClick(_ref2) {
    var onChange = _ref2.onChange;
    return function (_ref3) {
      var currentTarget = _ref3.currentTarget;
      var value = currentTarget.dataset.value;
      onChange(value); // Workaround for annoying Safari issue where the input is
      // focused everytime the value is changed via one of the buttons

      setTimeout(function () {
        currentTarget.focus();
      }, 0);
    };
  }
}), pure);
var InvestmentPicker = enhance(function (props) {
  return /*#__PURE__*/React.createElement(Container, {
    className: props.className
  }, /*#__PURE__*/React.createElement(CurrencyInput, {
    autoFocus: true,
    maxValue: props.maxValue,
    maxValueError: props.maxValueError,
    minValue: props.minValue,
    minValueError: props.minValueError,
    onChange: props.onChange,
    value: props.value,
    label: props.currencyInputLabel,
    name: props.currencyInputLabel
  }), /*#__PURE__*/React.createElement(PresetValues, null, props.values.map(function (value) {
    return /*#__PURE__*/React.createElement(ValueButton, {
      "data-value": value,
      onClick: props.handleClick,
      key: value,
      isSelected: props.value === value
    }, "$", value, /*#__PURE__*/React.createElement(Ink, {
      opacity: 0.02
    }));
  })));
});
export { InvestmentPicker };